export const orderTypes = {
    ADD_ITEM: "ORDER_ADD_ITEM",
    EDIT_ITEM: "ORDER_EDIT_ITEM",
    REMOVE_ITEM: "ORDER_REMOVE_ITEM",
    CLEAR: "ORDER_CLEAR",
    SET_ORDER_ID: "ORDER_SET_ORDER_ID",
    SET_INTEGRATION_ID: "ORDER_SET_INTEGRATION_ID"
}